import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { usePopper } from 'react-popper';
import Draggable from 'react-draggable';
import { useResizeDetector } from 'react-resize-detector';
import styles from './createbox.module.scss';
import eventcontentStyles from '../EventContent/eventcontent.module.scss';
import { ModalClose } from '@web-common/components/UI/Icons/icons';
import EventBody from './EventBody';
import { ScheduleSyncObInitiator } from '../../data';
const CreateScheduleBox = ({ onCancel, selectDate, getReferenceElement, onSyncCancel, onTimeRelatedValuesChange, updatePostion, defaultContactList, source = ScheduleSyncObInitiator.MAIN_MODULE, }) => {
    const eventBodyRef = useRef(null);
    const [popperElement, setPopperElement] = useState(null);
    const { width, height } = useResizeDetector({ targetRef: { current: popperElement } });
    const { styles: popperStyles, attributes, update, } = usePopper(getReferenceElement(), popperElement, {
        placement: 'right-start',
        modifiers: [
            {
                name: 'preventOverflow',
                options: {
                    boundary: document.querySelector('#schduleModule'),
                    altAxis: !0,
                    padding: 8,
                },
            },
            {
                name: 'offset',
                options: {
                    offset: [0, 2],
                },
            },
        ],
    });
    const maskRef = useRef(null);
    useEffect(() => {
        if (width && height && update) {
            update();
        }
    }, [width, height, updatePostion]);
    useEffect(() => {
        const triggerCancel = (e) => {
            var _a, _b;
            if (maskRef.current === e.target) {
                (_b = (_a = eventBodyRef.current) === null || _a === void 0 ? void 0 : _a.triggerCancel) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
        };
        window.addEventListener('mousedown', triggerCancel);
        return () => {
            window.removeEventListener('mousedown', triggerCancel);
        };
    }, [popperElement]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: maskRef, className: styles.mask }),
        React.createElement(Draggable, { handle: ".drag-header", positionOffset: { x: '-50%', y: '-50%' } },
            React.createElement("div", Object.assign({ ref: setPopperElement, style: popperStyles.popper, className: classnames(eventcontentStyles.modal, styles.modal, {
                    [styles.modalCenter]: getReferenceElement() === null,
                }) }, attributes.popper),
                React.createElement("div", { className: classnames(styles.header, 'sirius-no-drag drag-header') },
                    React.createElement(ModalClose, { className: `dark-invert ${styles.close}`, onClick: () => { var _a, _b; return (_b = (_a = eventBodyRef.current) === null || _a === void 0 ? void 0 : _a.triggerCancel) === null || _b === void 0 ? void 0 : _b.call(_a); } })),
                React.createElement(EventBody, { source: source, defaultContactList: defaultContactList, onTimeRelatedValuesChange: onTimeRelatedValuesChange, onSyncCancel: onSyncCancel, onCancel: onCancel, selectDate: selectDate, ref: eventBodyRef })))));
};
export default CreateScheduleBox;
